import styled from '@emotion/styled';
import type { MicrositeProfile } from '~/model';

const Section = styled.section`
	padding: 3rem 1.5rem 4rem;
`;

const Inner = styled.div`
	max-width: 72rem;
	margin: 0 auto;
	display: grid;
	grid-template-columns: 1fr;
	gap: 2rem;
	@media (min-width: ${(props) => props.theme.viewport.medium}px) {
		grid-template-columns: 1fr 2fr;
		align-items: start;
	}
`;

const Photo = styled.img`
	width: 16rem;
	height: 16rem;
	object-fit: cover;
`;

const Info = styled.div`
	display: grid;
	gap: 0.5rem;
	font-size: 1.25rem;
`;

export default function ProfileBlockDelta({ profiles }: { profiles: MicrositeProfile[] }) {
	if (profiles.length === 0) return null;
	const profile = profiles[0];

	return (
		<Section id="contact">
			<Inner>
				{profile.headshot?.medium_1x && <Photo src={profile.headshot.medium_1x} alt={profile.name} />}
				<Info>
					<strong>{profile.name}</strong>
					{profile.title && <span>{profile.title}</span>}
					{profile.company && <span>{profile.company}</span>}
					{profile.phone && <span>{profile.phone}</span>}
					{profile.email && <span>{profile.email}</span>}
					{profile.license && <span>{profile.license}</span>}
				</Info>
			</Inner>
		</Section>
	);
}
